import { render } from "./TemplateSelector.vue?vue&type=template&id=1a4288dc&scoped=true"
import script from "./TemplateSelector.vue?vue&type=script&lang=js"
export * from "./TemplateSelector.vue?vue&type=script&lang=js"

import "./TemplateSelector.vue?vue&type=style&index=0&id=1a4288dc&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4288dc"]])

export default __exports__